<template>
  <button
    data-test-id="customers-table-view-button"
    type="button"
    class="tw-block tw-mx-2 tw-rounded-full tw-border-none tw-bg-primary-grey-100/0 tw-text-primary-grey-950 tw-outline-none tw-ring-4 tw-ring-primary-grey-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-primary-grey-100 hover:tw-text-primary-grey-950 hover:tw-ring-primary-grey-100 active:tw-bg-primary-grey-200 active:tw-ring-primary-grey-200"
    @click="$emit('clicked')"
  >
    <cb-icon-view :width="18" />
  </button>
</template>

<script setup lang="ts">
defineEmits(["clicked"]);
</script>
